import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getOfficeDarkReason = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Common/DarkReason`
  );
  return data;
};
